export class ChatApiError {
	message?: string;
	isBlocking: boolean;
	constructor(isBlocking: boolean, message?: string) {
		this.message = message;
		this.isBlocking = isBlocking;
	}
}
